import React from 'react'
import PropTypes from 'prop-types'

// HeroSection: A component that displays a hero section with a background image, logo, and a call-to-action button.
export default function HeroSection({ section }) {
  const {
    button_arrow,
    button_background,
    button_background_hover,
    button_color,
    button_color_hover,
    button_label,
    button_url,
    config: { title_with_background },
    image_url,
    link_open_in_new_tab,
    logo_alt,
    logo_url,
    node_id,
    title,
    title_background_color,
    title_color,
  } = section

  const buttonStyles = {
    '--button-background': button_background,
    '--button-background-hover': button_background_hover,
    '--button-color': button_color,
    '--button-color-hover': button_color_hover,
  }

  return (
    <div
      className="imageOverlay"
      key={node_id}
      style={{ backgroundImage: `url(${image_url})` }}
    >
      <div className="imageOverlay_container container">
        <div
          className={`imageOverlay_row ${title_with_background ? 'imageOverlay_title-with-bg' : ''}`}
        >
          <div
            className="imageOverlay_content m-0"
            style={
              title_with_background
                ? { backgroundColor: title_background_color }
                : {}
            }
          >
            {logo_url !== '' && (
              <img
                alt={logo_alt}
                className="imageOverlay_logo"
                src={logo_url}
              />
            )}
            <h2
              className="imageOverlay_heading mb-0"
              style={title_color ? { color: title_color } : {}}
            >
              <strong>{title}</strong>
            </h2>
            {section.button_url.trim() !== '' &&
              section.button_label.trim() !== '' && (
                <a
                  aria-label="Learn more"
                  className={`landingLinkBtn mt-5 ${button_arrow}`}
                  href={button_url}
                  rel={link_open_in_new_tab ? 'noreferrer noopener' : ''}
                  style={buttonStyles}
                  target={link_open_in_new_tab ? '_blank' : '_self'}
                >
                  {button_label}
                </a>
              )}
          </div>
        </div>
      </div>
    </div>
  )
}

HeroSection.propTypes = {
  section: PropTypes.shape({
    button_arrow: PropTypes.string.isRequired,
    button_background: PropTypes.string.isRequired,
    button_background_hover: PropTypes.string.isRequired,
    button_color: PropTypes.string.isRequired,
    button_color_hover: PropTypes.string.isRequired,
    button_label: PropTypes.string.isRequired,
    button_url: PropTypes.string.isRequired,
    config: PropTypes.shape({
      title_with_background: PropTypes.bool.isRequired,
    }).isRequired,
    image_url: PropTypes.string.isRequired,
    link_open_in_new_tab: PropTypes.bool.isRequired,
    logo_alt: PropTypes.string.isRequired,
    logo_url: PropTypes.string.isRequired,
    node_id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    title_background_color: PropTypes.string.isRequired,
    title_color: PropTypes.string.isRequired,
  }).isRequired,
}
